module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mira's Maids","short_name":"Mira's","start_url":"/","background_color":"#3f5cc4","theme_color":"#1d2e6b","display":"standalone","icon":"static/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"263f7aa2e3a0eda1a3e6d39bf2e48e0b"},
    }]
